import {
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { IconTemp } from '@assets/images/main';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/logisticsAsset/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/cityEnergy/img/1.avif';
import image2 from '@src/assets/images/solution/cityEnergy/img/2.avif';
import image3 from '@src/assets/images/solution/cityEnergy/img/3.avif';
import image4 from '@src/assets/images/solution/cityEnergy/img/4.avif';
import image5 from '@src/assets/images/solution/cityEnergy/img/5.avif';
import image6 from '@src/assets/images/solution/cityEnergy/img/6.avif';

export default {
  type: '에너지/환경 솔루션',

  banner: {
    title: '원자력 발전소에서도 놓치지 않는 지게차 위치추적 시스템',
    desc: 'UWB 위치기반 기술로 지게차의 이동을 추적하고, 폐기물 운반 경로를 자동 저장해 감독기관 대응과 자산 보안 강화를 동시에 실현합니다.',
  },

  video: {
    title: '강한 구조물, 약한 신호. ORBRO는 그 한계를 넘습니다.',
    desc: '철판으로 덮인 공간과 10미터 이상의 높은 천장에서도, ORBRO의 위치추적 기술은 신호를 정확히 수신합니다. 발전소 내 자산이 어디에 있었는지, 언제 이동했는지, 누가 반출했는지까지 모두 데이터로 증빙 가능합니다.',
    play: video,
  },

  func: [
    {
      theme: '극한 환경에서도 끊김 없는 고정밀 위치추적',
      title: '금속 밀폐 구조에서도 안정적인 위치 데이터 확보',
      desc: '철재 구조물로 둘러싸인 폐쇄된 공간에서도 ORBRO의 위치 추적 시스템은 신호 손실 없이 안정적인 성능을 유지합니다. 기존 TDoA 기술로는 추적이 불가능했던 환경에서도 ±30cm 이내의 정밀한 위치 데이터를 제공합니다.',
      sub1: '높은 정확도 제공',
      icon1: IconRulerGray,
      sub2: '빠른 데이터 연동',
      icon2: IconShareGray,
      image: image1,
    },
    {
      title: '높은 천장에도 설치가능',
      desc: '10m 이상의 천장 높이를 가진 공간에서도 정확한 위치 인식이 가능합니다. 최소한의 인프라 설치만으로 넓은 공간을 커버하여 설치 효율성과 운영 편의성을 동시에 확보합니다.',
      sub1: '위험 자산 지정',
      icon1: IconWarningGray,
      sub2: '대응 방식 설정',
      icon2: IconBellGray,
      image: image2,
    },
    {
      title: '고속 이동 및 복잡한 동선에서도 끊김 없는 수신',
      desc: '지게차가 빠르게 이동하거나 좁은 구역을 반복 운행하더라도 신호 손실 없이 모든 동선이 정확히 기록됩니다. 실내 반사 환경에서도 끊김 없는 데이터를 확보할 수 있습니다.',
      sub1: '높은 정확도 제공',
      icon1: IconRulerGray,
      sub2: '빠른 데이터 연동',
      icon2: IconChainLinkGray,
      image: image3,
    },
    {
      theme: '정밀 알고리즘과 이력 기반 운영 최적화',
      title: 'Advanced TDoA 고정밀 알고리즘 적용',
      desc: '시간 동기화, 시계 오차 보정, 최소자승법 기반 위치 계산 등 6단계 정밀 처리 과정을 거쳐 복잡한 환경에서도 정확한 위치를 계산합니다. ORBRO만의 기술로 산업 현장에 최적화된 정밀도와 안정성을 확보했습니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image4,
    },
    {
      title: 'Multipath/NLOS 환경 대응 필터링',
      desc: '신호 반사나 비가시선(NLOS) 조건에서 왜곡된 데이터를 자동 제거하여 실제 경로 기반의 정밀 위치를 제공합니다. Multipath 환경에서도 98% 이상의 위치 성공률을 유지합니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image5,
    },
    {
      title: '지게차 이동 이력 타임라인 관리',
      desc: '지게차의 이동 경로와 위치 변화가 시간순으로 저장되며, 특정 구간의 체류 시간이나 경로 이탈도 분석할 수 있습니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image6,
    },
  ],

  subfunc: {
    title: '주요기능 요약',
    desc: '의료 폐기물은 끝까지 긴장을 놓쳐서는 안됩니다. 작은 방심과 실수로도 큰 의료 사고로 이어질 수 있습니다. 따라서 매우 정밀한 관리가 필요하며 안전이 보장되어야 합니다.<br/>오브로는 안전하고 효율적인 의료 시설을 구축하기 위해 다양한 기능을 제공합니다.',

    data: [
      {
        icon: IconZoneGray,
        title: '금속 구조물 공간 추적 가능',
        desc: '천장이 높고 금속 구조물로 된 밀폐 구역에서도 안정적인 데이터 확보가 가능합니다.',
      },
      {
        icon: IconRulerGray,
        title: 'ATDoA 정밀 측위 지원',
        desc: '고속 이동 차량도 ±50cm 정밀도로 실시간 추적 가능합니다.',
      },
      {
        icon: IconChainLink,
        title: 'Multipath/NLOS 내장',
        desc: '반사, 차단 등 복잡한 구조 환경에서도 오차를 최소화합니다.',
      },
      {
        icon: IconDashboard,
        title: '실시간 지게차 위치 시각화',
        desc: '지게차 등의 차량 위치를 대시보드에서 실시간으로 확인할 수 있습니다.',
      },
      {
        icon: IconRoute,
        title: '이동 경로 타임라인 기록',
        desc: '지게차의 이동 이력을 시간대별로 저장하고 시각화합니다.',
      },
      {
        icon: IconBinocularsGray,
        title: '고속 이동 중에도 연속 추적',
        desc: '속도가 빠른 차량도 끊김 없이 연속적인 위치 추적이 가능합니다.',
      },
      {
        icon: IconChartRadius,
        title: '안전 감사 대응 자료 활용',
        desc: '이력 기반 데이터는 외부 감사나 규제 대응 시 활용할 수 있는 증빙 자료로 활용됩니다.',
      },
      {
        icon: IconWarning,
        title: '지정 구역 출입 자동 감지',
        desc: '중요 구역의 출입 여부를 자동으로 감지하고 로그를 남깁니다.',
      },
      {
        icon: IconBell,
        title: '비정상 정지/대기 시 알림',
        desc: '지정 시간 이상 정지 상태가 지속되면 관리자에게 알림이 발송됩니다.',
      },
      {
        icon: IconRoute,
        title: '충돌 예방을 위한 동선 모니터링',
        desc: '복수 차량의 경로를 실시간으로 분석해 이동 경로 충돌을 방지합니다.',
      },
    ],
  },

  system: {
    title: '시스템 구성',
    img: rtlsSystem,
  },

  productTitle: '제품 구성',
  product: [
    {
      tag: 'assetPackage',
    },
    {
      tag: 'workerPackage',
    },
  ],

  contents: [
    {
      data: 'medicalPatient',
    },
    {
      data: 'officeAsset',
    },
    {
      data: 'blogMedical',
    },
    {
      data: 'blogRTLS',
    },
  ],
};
